import React from "react";
import styled from "styled-components";
import Card from "../Card";
import Tooltip from "./Tooltip";
import GameRule from "../Types/GameRule";

const CardContainer = styled.div`
  font-size: 5vw;
  display: flex;
  justify-content: center;
  padding-bottom: 3rem;
`;

const HardTooltip = () => (
  <Tooltip>
    <h1>Hard mode</h1>
    <h4>In hard mode some cards will have special rules as described below.</h4>
    <h2>Skull card</h2>
    <p>
      You (the player) must cover this card within the same turn (meaning you
      cannot leave this card showing when your turn is over).
    </p>
    <CardContainer>
      <Card gameRule={GameRule.Hard} number={17} gameId={0}>
        13
      </Card>
    </CardContainer>
    <h2>Three card</h2>
    <p>
      This card means that when you play it, you must place three and exactly
      three cards in that turn. When combined with a stop card, the stop card
      must go last.
    </p>
    <CardContainer>
      <Card gameRule={GameRule.Hard} number={19} gameId={0}>
        13
      </Card>
    </CardContainer>
    <h2>Stop card</h2>
    <p>
      This card means your turn is over when it's played. You are not allowed to
      play any cards after a stop card, even if you played it as your first
      card.
    </p>
    <CardContainer>
      <Card gameRule={GameRule.Hard} number={6} gameId={0}>
        13
      </Card>
    </CardContainer>
    <h2>No magic</h2>
    <p>
      As long as this card is showing in any of the 4 stacks, no player is
      allowed to use magic in any of the 4 stacks.
    </p>
    <CardContainer>
      <Card gameRule={GameRule.Hard} number={21} gameId={0}>
        13
      </Card>
    </CardContainer>
    <h1>Single stack</h1>
    <p>
      As long as this card is showing in any of the 4 stacks, the current player
      must play all their cards the same stack (of their choice).
    </p>
    <CardContainer>
      <Card gameRule={GameRule.Hard} number={9} gameId={0}>
        13
      </Card>
    </CardContainer>
    <h1>Draw only one</h1>
    <p>
      As long as this card is showing in any of the 4 stacks, each player will
      draw only one card at the end of their turn (meaning you will end up with
      fewer cards.
    </p>
    <CardContainer>
      <Card gameRule={GameRule.Hard} number={13} gameId={0}>
        13
      </Card>
    </CardContainer>
    <h1>Silent card</h1>
    <p>
      As long as this card is showing in any of the 4 stacks, the players are
      not allowed to communicate (in any form) with each other.
    </p>
    <CardContainer>
      <Card gameRule={GameRule.Hard} number={26} gameId={0}>
        13
      </Card>
    </CardContainer>
  </Tooltip>
);

export default HardTooltip;
